import Typography, { TypographyProps } from "@mui/material/Typography";
import RCountUp, { CountUpProps } from "react-countup";

export function CountUp({ ...rest }: CountUpProps & TypographyProps) {
  return (
    <Typography
      overflow="hidden"
      maxWidth="13vw"
      textOverflow="ellipsis"
      {...rest}
    >
      <RCountUp separator="." decimal="," {...rest} />
    </Typography>
  );
}
